import { render, staticRenderFns } from "./EndCeremony.vue?vue&type=template&id=12c96d4b&scoped=true"
import script from "./EndCeremony.vue?vue&type=script&lang=js"
export * from "./EndCeremony.vue?vue&type=script&lang=js"
import style0 from "./EndCeremony.vue?vue&type=style&index=0&id=12c96d4b&prod&scoped=true&lang=scss"
import style1 from "./EndCeremony.vue?vue&type=style&index=1&id=12c96d4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c96d4b",
  null
  
)

export default component.exports